// Project report (16_ProjectReport.jsx) — the Integrated Development / R&D / Project Owner / Ticket Station
// report tabs, in the portal's four languages (2026-10-21). Statuses, stage values, owner, team and ticket
// status VALUES come from the data and are compared in the code, so they are not here; only the screen's own
// words are. The Ticket Station's three manager statuses reuse st.tkPending / st.tkDone / st.tkCancelled and the
// Project Tracker's cards reuse st.pt*, so the report and those screens say the same thing.
const en = {
  team: {
    special: 'Integrated Development Team',
    inline: 'Inline Development Team',
    rd: 'R&D Team',
    owner: 'Report for Project Owner',
    tickets: 'Report for Ticket Station',
  },
  tab: {
    special: 'Integrated Development Team',
    rd: 'R&D Team',
    owner: 'Project Owner',
    tickets: 'Ticket Station',
  },
  exportExcel: 'Export Excel',
  loading: 'Loading project report...',
  loadError: 'Error loading report: {{error}}',
  loadFailed: 'Failed to load projects',
  exportNone: 'No report table to export.',
  exportFailedStatus: 'Export failed ({{status}})',
  exportFailed: 'Export failed: {{error}}',
  subDev: 'Generated {{date}} · {{projects}} active projects · {{skus}} SKU',
  subRd: 'Generated {{date}} · {{shown}} of {{total}} projects · {{skus}} SKU',
  subOwner: 'Generated {{date}} · {{projects}} projects · {{skus}} SKU · {{owners}} owners',
  pendingNotCounted: '{{n}} SKU pending approval not counted',
  subTickets: 'Generated {{date}} · {{n}} tickets · {{open}} open · {{overdue}} overdue · {{unsent}} never emailed',
  projSku: '({{projects}} projects · {{skus}} SKU)',
  projectsN: '{{n}} projects',
  projectsOf: '{{shown}} / {{total}} projects',
  skuN: '{{n}} SKU',
  rowsN: '{{n}} rows',
  sortBy: 'Sort by {{label}}',
  unassigned: 'unassigned',
  unassignedDev: 'Unassigned',
  other: 'Other',
  any: 'any',
  daysShort: '{{n}}d',
  pinAll: 'Tick / untick every row',
  filter: {
    all: 'All',
    none: 'None',
    selected: '{{n}} selected',
    noOptions: 'No options',
    clear: 'Clear Filters',
    allSopTeams: 'All Sales OP Teams',
    allOwners: 'All Project Owners',
    allReceiving: 'All Receiving Teams',
    allRequesters: 'All Requesters',
    allCodes: 'All Ticket Codes',
    allStatuses: 'All Statuses',
    allStatus: 'All Status',
    allProto: 'All Proto',
    allCategory: 'All Category',
    allAssigned: 'All Assigned',
    allItem: 'All Item',
    allLocation: 'All Location',
    last7: 'Last 7 days',
    from: 'From',
    to: 'To',
    raisedFrom: 'Raised from',
    developer: 'Developer filter:',
  },
  col: {
    baseId: 'Base ID',
    styleItem: 'Style / Item',
    round: 'Round',
    location: 'Location',
    projectSku: 'Project SKU',
    devDue: 'Development Due',
    rmReady: 'RM Ready',
    sampleFinish: 'Sample Finish',
    received: 'Received',
    qty: 'QTY',
    status: 'Status',
    dday: 'D-day',
    remarks: 'Remarks',
    category: 'Category',
    project: 'Project',
    specialProject: 'Special Project',
    assignedTo: 'Assigned to',
    exfShipDate: 'EXF Ship date',
    weeksLeft: 'Weeks left',
    item: 'Item',
    estQty: 'Est. QTY',
    projectStatus: 'Project Status',
    ldSoff: 'L/D S/OFF',
    proto: 'Proto',
    counter: 'Counter',
    costing: 'Costing',
    handoffMeeting: 'Hand-off Meeting',
    alloc: 'Alloc',
    shipDate: 'Ship Date',
    handoff: 'Hand-off',
    shipmentStatus: 'Shipment Status',
    payment: 'Payment',
    dueDays: 'Due days',
    sampleQty: 'Sample QTY',
    rdRound: 'R&D Round',
    remark: 'Remark',
    pin: 'Pin',
    prjId: 'PRJ ID',
    skuId: 'SKU ID',
    prjOwner: 'PRJ owner',
    picAssigned: 'PIC assigned',
    exfDate: 'EXF date',
    sku: 'SKU',
    progress: 'Progress',
    approved: 'Approved',
    developer: 'Developer',
    total: 'Total',
    ttl: 'TTL',
    sample: 'Sample',
    noSample: 'No sample',
  },
  thNote: {
    devDesigner: 'developer / designer',
    exfRule: 'unfinished SKUs — TBA first, else the nearest',
    avgSkus: 'avg of SKUs',
    mostActive: 'most active SKU',
    dateBy: 'date · by',
    project: 'project',
    sku: 'SKU',
    created: 'created',
    stillOpen: 'still open',
  },
  note: {
    comments: 'Comments',
    saved: 'Saved',
    placeholder: 'Add notes here...',
  },
  dev: {
    sec11: 'Section 1-1: Per Developer',
    samplesN: '({{n}} samples)',
    chunkOf: '({{start}}-{{end}} of {{total}} samples)',
    noSamples: 'No samples match the selected filters.',
    sec12: 'Section 1-2: Per Vendor',
    otherSuppliers: 'Other Suppliers',
    sec2: 'Section 2: Post Handoff',
    noProjects: 'No projects.',
    onHoldSec: 'STATUS - On Hold / Inactive',
    onHoldTitle: 'On Hold / Inactive',
    noOnHold: 'No projects on hold.',
  },
  rd: {
    noRows: 'No R&D projects match the selected filters.',
    untick: 'Untick to leave this row out of the next pinned view',
    pinView: 'Pin this view',
    mergeNeed: 'Tick at least two pinned views to merge',
    mergeDo: 'Merge the ticked views into one new pin',
    mergeSelected: 'Merge selected ({{n}})',
    clearPinned: 'Clear pinned ({{n}})',
    includeInMerge: 'Include this view in the next merge',
    pinned: 'Pinned {{n}} — {{label}}',
    removeSnapshot: 'Remove this snapshot',
    merged: 'Merged ({{n}}): {{labels}}',
    mergedDup: '{{label}} — {{n}} duplicate row(s) removed',
    noFilter: 'No filter (all rows)',
    fPart: '{{label}}: {{values}}',
    fStatus: 'Status',
    fProto: 'Proto',
    fCategory: 'Category',
    fAssigned: 'Assigned',
    fItem: 'Item',
    fLocation: 'Location',
  },
  ov: {
    title: '4. PROJECT DEVELOPMENT OVERVIEW - Work Allocation',
    note: '(Project Status: On Track / Concern / Delayed. Not included: Post Hand-off & On Hold/Inactive)',
    numProject: 'Number of Project',
    numProjectNote: '(On Track / Concern / Delayed; not included Post Hand-off)',
    numSku: 'Number of SKU',
    numSkuNote: '(On Track / Concern / Delayed SKU; not included Post Hand-off)',
    stageSummary: 'Development Stage - Developer Summary',
    chartProject: 'Number of Project by Developer',
    chartSku: 'Number of SKU by Developer',
    inDev: 'In Development',
    postHandoff: 'Post Hand-off',
    postShipment: 'Post Shipment',
    onHold: 'On Hold',
    wlTitle: 'Current Workload Snapshot - Developer Owner',
    wlIntro: 'What each person is holding right now. Developer —',
    wlInCharge: 'In charge',
    wlInChargeText: ': samples they own until finished (including those awaiting feedback — a comment means another round to make).',
    wlInProgress: 'In progress',
    wlInProgressText: ': rounds before send the dev is handling now (RM ordering, coordination, build, checks).',
    wlChart: 'Current Workload by Developer',
    inChargeBase: 'In Charge (Base ID)',
    inProgressSample: 'In Progress (Sample ID)',
    noWorkload: 'No active sample workload found.',
  },
  owner: {
    sec1: 'Section 1: Project portfolio by owner & category',
    sampleCreated: 'Sample created',
    noSampleYet: 'No sample yet',
    chartProjects: 'Projects by owner',
    chartProjectsNote: 'split by category',
    chartSkus: 'SKUs by owner',
    chartSkusNote: 'sampled, or still open with no sample',
    noData: 'No data for this filter.',
    completedSku: 'Completed SKU',
    droppedSku: 'Dropped SKU',
    activeSku: 'Active SKU',
    noSampleSub: 'still open, no sample round',
    sec2: 'Section 2: Project status by owner',
    noMatch: 'No project matches this filter.',
    chunk: '{{start}}-{{end}} of {{total}} projects',
    approvedSec: 'Projects approved · {{range}}',
    projectsApproved: 'Projects approved',
    inPeriod: 'in this period',
    skusApproved: 'SKUs approved',
    acrossProjects: 'across those projects',
    noApproved: 'No project was approved in this period.',
    sec3: 'Section 3: Tickets on these projects',
    sec3Counts: '({{open}} open · {{overdue}} overdue · {{never}} never emailed)',
    noTickets: 'No ticket has been raised on these projects.',
    raised: 'Raised',
    open: 'Open',
    overdue: 'Overdue',
    neverEmailed: 'Never emailed',
    oldestOpen: 'Oldest open',
    sec4: 'Section 4: SKU with no sample yet',
    allSampled: 'Every SKU in this filter has a sample.',
    nsCountFiltered: '{{n}} SKU of {{total}} · filtered',
    clearFilters: 'Clear filters',
  },
  tk: {
    colTicket: 'Ticket',
    colProject: 'Project',
    colProjectName: 'Project name',
    colAsked: 'What was asked for',
    colReceiving: 'Receiving team',
    colOwner: 'Project owner',
    colDue: 'Due',
    colManager: 'Manager status',
    colAssignee: 'Assignee status',
    total: 'Total',
    chartAria: 'Tickets {{title}}',
    cardsAria: 'Tickets by card: {{list}}',
    raisedSub: 'tickets in this view',
    overdueSub: 'past the due date',
    subPending: 'the manager has not closed it',
    subDone: 'the manager closed it',
    subCancelled: 'the manager cancelled it',
    byCard: 'Tickets by card',
    s1: 'Section 1: Open',
    s1note: 'Every ticket the manager has not closed. Only the requester, project owner or team manager can close one.',
    s1empty: 'Nothing is open.',
    s2: 'Section 2: Overdue',
    s2empty: 'Nothing is past its due date.',
    s3: 'Section 3: Raised but never emailed',
    s3note: 'Nobody on the receiving team has been told these exist. Ticket Station shows a Send button on each of them.',
    s3empty: 'Every open ticket has been emailed.',
    s4: 'Section 4: Open, but the receiving team says Done',
    s4note: 'The receiving team has answered Done and the ticket is still open. The work looks finished; somebody has to close it.',
    s4empty: 'Nothing is waiting on a close.',
    s5: 'Section 5: By receiving team',
    s6: 'Section 6: By project owner',
    s7: 'Section 7: By ticket code',
    keyReceiving: 'Receiving team',
    keyOwner: 'Project owner',
    keyCode: 'Ticket code',
    noMatch: 'No tickets match this filter.',
  },
};

const ko = {
  team: {
    special: '통합 개발팀',
    inline: '인라인 개발팀',
    rd: 'R&D 팀',
    owner: '프로젝트 오너 리포트',
    tickets: '티켓 스테이션 리포트',
  },
  tab: {
    special: '통합 개발팀',
    rd: 'R&D 팀',
    owner: '프로젝트 오너',
    tickets: '티켓 스테이션',
  },
  exportExcel: '엑셀 내보내기',
  loading: '프로젝트 리포트를 불러오는 중...',
  loadError: '리포트를 불러오지 못했습니다: {{error}}',
  loadFailed: '프로젝트를 불러오지 못했습니다',
  exportNone: '내보낼 리포트 표가 없습니다.',
  exportFailedStatus: '내보내기 실패 ({{status}})',
  exportFailed: '내보내기 실패: {{error}}',
  subDev: '{{date}} 생성 · 진행 프로젝트 {{projects}}건 · SKU {{skus}}개',
  subRd: '{{date}} 생성 · 프로젝트 {{total}}건 중 {{shown}}건 · SKU {{skus}}개',
  subOwner: '{{date}} 생성 · 프로젝트 {{projects}}건 · SKU {{skus}}개 · 오너 {{owners}}명',
  pendingNotCounted: '승인 대기 SKU {{n}}개 제외',
  subTickets: '{{date}} 생성 · 티켓 {{n}}건 · 열림 {{open}}건 · 기한 초과 {{overdue}}건 · 메일 미발송 {{unsent}}건',
  projSku: '(프로젝트 {{projects}}건 · SKU {{skus}}개)',
  projectsN: '프로젝트 {{n}}건',
  projectsOf: '프로젝트 {{shown}} / {{total}}건',
  skuN: 'SKU {{n}}개',
  rowsN: '{{n}}행',
  sortBy: '{{label}} 기준 정렬',
  unassigned: '미지정',
  unassignedDev: '미지정',
  other: '기타',
  any: '전체',
  daysShort: '{{n}}일',
  pinAll: '모든 행 선택 / 해제',
  filter: {
    all: '전체',
    none: '없음',
    selected: '{{n}}개 선택',
    noOptions: '옵션 없음',
    clear: '필터 해제',
    allSopTeams: '전체 Sales OP 팀',
    allOwners: '전체 프로젝트 오너',
    allReceiving: '전체 수신 팀',
    allRequesters: '전체 요청자',
    allCodes: '전체 티켓 코드',
    allStatuses: '전체 상태',
    allStatus: '전체 상태',
    allProto: '전체 프로토',
    allCategory: '전체 카테고리',
    allAssigned: '전체 담당자',
    allItem: '전체 품목',
    allLocation: '전체 위치',
    last7: '최근 7일',
    from: '시작',
    to: '종료',
    raisedFrom: '생성일 시작',
    developer: '개발자 필터:',
  },
  col: {
    baseId: 'Base ID',
    styleItem: '스타일 / 품목',
    round: '라운드',
    location: '위치',
    projectSku: '프로젝트 SKU',
    devDue: '개발 기한',
    rmReady: '원자재 준비',
    sampleFinish: '샘플 완료일',
    received: '입고일',
    qty: '수량',
    status: '상태',
    dday: 'D-day',
    remarks: '비고',
    category: '카테고리',
    project: '프로젝트',
    specialProject: '특별 프로젝트',
    assignedTo: '담당자',
    exfShipDate: 'EXF 선적일',
    weeksLeft: '남은 주',
    item: '품목',
    estQty: '예상 수량',
    projectStatus: '프로젝트 상태',
    ldSoff: '랩딥 승인',
    proto: '프로토',
    counter: '카운터',
    costing: '원가 산출',
    handoffMeeting: '핸드오프 미팅',
    alloc: '배정',
    shipDate: '선적일',
    handoff: '핸드오프',
    shipmentStatus: '선적 상태',
    payment: '결제',
    dueDays: '기한 일수',
    sampleQty: '샘플 수량',
    rdRound: 'R&D 라운드',
    remark: '비고',
    pin: '고정',
    prjId: 'PRJ ID',
    skuId: 'SKU ID',
    prjOwner: 'PRJ 오너',
    picAssigned: '담당 PIC',
    exfDate: 'EXF 일자',
    sku: 'SKU',
    progress: '진행률',
    approved: '승인',
    developer: '개발자',
    total: '합계',
    ttl: '합계',
    sample: '샘플',
    noSample: '샘플 없음',
  },
  thNote: {
    devDesigner: '개발자 / 디자이너',
    exfRule: '미완료 SKU — TBA 우선, 없으면 가장 가까운 날짜',
    avgSkus: 'SKU 평균',
    mostActive: '가장 활발한 SKU',
    dateBy: '일자 · 승인자',
    project: '프로젝트',
    sku: 'SKU',
    created: '생성됨',
    stillOpen: '진행 중',
  },
  note: {
    comments: '코멘트',
    saved: '저장됨',
    placeholder: '메모를 입력하세요...',
  },
  dev: {
    sec11: '섹션 1-1: 개발자별',
    samplesN: '(샘플 {{n}}개)',
    chunkOf: '(샘플 {{total}}개 중 {{start}}-{{end}})',
    noSamples: '선택한 필터에 맞는 샘플이 없습니다.',
    sec12: '섹션 1-2: 벤더별',
    otherSuppliers: '기타 공급업체',
    sec2: '섹션 2: 핸드오프 이후',
    noProjects: '프로젝트가 없습니다.',
    onHoldSec: '상태 - 보류 / 비활성',
    onHoldTitle: '보류 / 비활성',
    noOnHold: '보류 중인 프로젝트가 없습니다.',
  },
  rd: {
    noRows: '선택한 필터에 맞는 R&D 프로젝트가 없습니다.',
    untick: '선택을 해제하면 다음 고정 보기에서 이 행이 빠집니다',
    pinView: '이 보기 고정',
    mergeNeed: '병합하려면 고정 보기를 두 개 이상 선택하세요',
    mergeDo: '선택한 보기를 새 고정 보기 하나로 병합',
    mergeSelected: '선택 병합 ({{n}})',
    clearPinned: '고정 보기 지우기 ({{n}})',
    includeInMerge: '다음 병합에 이 보기 포함',
    pinned: '고정 {{n}} — {{label}}',
    removeSnapshot: '이 스냅샷 삭제',
    merged: '병합 ({{n}}): {{labels}}',
    mergedDup: '{{label}} — 중복 행 {{n}}개 제거',
    noFilter: '필터 없음 (전체 행)',
    fPart: '{{label}}: {{values}}',
    fStatus: '상태',
    fProto: '프로토',
    fCategory: '카테고리',
    fAssigned: '담당자',
    fItem: '품목',
    fLocation: '위치',
  },
  ov: {
    title: '4. 프로젝트 개발 개요 - 업무 배분',
    note: '(프로젝트 상태: On Track / Concern / Delayed. 제외: 핸드오프 이후 및 On Hold/Inactive)',
    numProject: '프로젝트 수',
    numProjectNote: '(On Track / Concern / Delayed; 핸드오프 이후 제외)',
    numSku: 'SKU 수',
    numSkuNote: '(On Track / Concern / Delayed SKU; 핸드오프 이후 제외)',
    stageSummary: '개발 단계 - 개발자 요약',
    chartProject: '개발자별 프로젝트 수',
    chartSku: '개발자별 SKU 수',
    inDev: '개발 중',
    postHandoff: '핸드오프 이후',
    postShipment: '선적 이후',
    onHold: '보류',
    wlTitle: '현재 업무량 - 개발 담당자',
    wlIntro: '각자가 지금 맡고 있는 일입니다. 개발자 —',
    wlInCharge: '담당',
    wlInChargeText: ': 완료될 때까지 맡고 있는 샘플 (피드백 대기 포함 — 코멘트가 오면 라운드를 하나 더 만들어야 합니다).',
    wlInProgress: '진행 중',
    wlInProgressText: ': 발송 전 개발자가 지금 처리 중인 라운드 (원자재 발주, 조율, 제작, 검수).',
    wlChart: '개발자별 현재 업무량',
    inChargeBase: '담당 (Base ID)',
    inProgressSample: '진행 중 (Sample ID)',
    noWorkload: '진행 중인 샘플 업무가 없습니다.',
  },
  owner: {
    sec1: '섹션 1: 오너 및 카테고리별 프로젝트 포트폴리오',
    sampleCreated: '샘플 생성됨',
    noSampleYet: '샘플 없음',
    chartProjects: '오너별 프로젝트',
    chartProjectsNote: '카테고리별 구분',
    chartSkus: '오너별 SKU',
    chartSkusNote: '샘플 생성 또는 샘플 없이 진행 중',
    noData: '이 필터에 해당하는 데이터가 없습니다.',
    completedSku: '완료 SKU',
    droppedSku: '드롭 SKU',
    activeSku: '진행 SKU',
    noSampleSub: '진행 중, 샘플 라운드 없음',
    sec2: '섹션 2: 오너별 프로젝트 상태',
    noMatch: '이 필터에 맞는 프로젝트가 없습니다.',
    chunk: '프로젝트 {{total}}건 중 {{start}}-{{end}}',
    approvedSec: '승인된 프로젝트 · {{range}}',
    projectsApproved: '승인 프로젝트',
    inPeriod: '이 기간',
    skusApproved: '승인 SKU',
    acrossProjects: '해당 프로젝트 전체',
    noApproved: '이 기간에 승인된 프로젝트가 없습니다.',
    sec3: '섹션 3: 이 프로젝트들의 티켓',
    sec3Counts: '(열림 {{open}} · 기한 초과 {{overdue}} · 메일 미발송 {{never}})',
    noTickets: '이 프로젝트들에 생성된 티켓이 없습니다.',
    raised: '생성',
    open: '열림',
    overdue: '기한 초과',
    neverEmailed: '메일 미발송',
    oldestOpen: '최장 미결',
    sec4: '섹션 4: 샘플이 없는 SKU',
    allSampled: '이 필터의 모든 SKU에 샘플이 있습니다.',
    nsCountFiltered: 'SKU {{total}}개 중 {{n}}개 · 필터 적용',
    clearFilters: '필터 해제',
  },
  tk: {
    colTicket: '티켓',
    colProject: '프로젝트',
    colProjectName: '프로젝트명',
    colAsked: '요청 내용',
    colReceiving: '수신 팀',
    colOwner: '프로젝트 오너',
    colDue: '기한',
    colManager: '매니저 상태',
    colAssignee: '담당 팀 상태',
    total: '합계',
    chartAria: '티켓 {{title}}',
    cardsAria: '카드별 티켓: {{list}}',
    raisedSub: '이 화면의 티켓',
    overdueSub: '기한 경과',
    subPending: '매니저가 아직 종료하지 않음',
    subDone: '매니저가 종료함',
    subCancelled: '매니저가 취소함',
    byCard: '카드별 티켓',
    s1: '섹션 1: 열림',
    s1note: '매니저가 종료하지 않은 모든 티켓입니다. 티켓은 요청자, 프로젝트 오너, 팀 매니저만 종료할 수 있습니다.',
    s1empty: '열린 티켓이 없습니다.',
    s2: '섹션 2: 기한 초과',
    s2empty: '기한이 지난 티켓이 없습니다.',
    s3: '섹션 3: 생성됐지만 메일 미발송',
    s3note: '수신 팀의 누구도 이 티켓이 있다는 것을 모릅니다. 티켓 스테이션에서 각 티켓에 Send 버튼이 표시됩니다.',
    s3empty: '열린 티켓은 모두 메일로 발송되었습니다.',
    s4: '섹션 4: 열려 있지만 수신 팀은 Done으로 답함',
    s4note: '수신 팀이 Done으로 답했지만 티켓은 아직 열려 있습니다. 작업은 끝난 것으로 보이니 누군가 종료해야 합니다.',
    s4empty: '종료를 기다리는 티켓이 없습니다.',
    s5: '섹션 5: 수신 팀별',
    s6: '섹션 6: 프로젝트 오너별',
    s7: '섹션 7: 티켓 코드별',
    keyReceiving: '수신 팀',
    keyOwner: '프로젝트 오너',
    keyCode: '티켓 코드',
    noMatch: '이 필터에 맞는 티켓이 없습니다.',
  },
};

const vi = {
  team: {
    special: 'Nhóm phát triển tích hợp',
    inline: 'Nhóm phát triển Inline',
    rd: 'Nhóm R&D',
    owner: 'Báo cáo cho Chủ dự án',
    tickets: 'Báo cáo cho Ticket Station',
  },
  tab: {
    special: 'Nhóm phát triển tích hợp',
    rd: 'Nhóm R&D',
    owner: 'Chủ dự án',
    tickets: 'Ticket Station',
  },
  exportExcel: 'Xuất Excel',
  loading: 'Đang tải báo cáo dự án...',
  loadError: 'Lỗi tải báo cáo: {{error}}',
  loadFailed: 'Không tải được dự án',
  exportNone: 'Không có bảng báo cáo nào để xuất.',
  exportFailedStatus: 'Xuất thất bại ({{status}})',
  exportFailed: 'Xuất thất bại: {{error}}',
  subDev: 'Tạo lúc {{date}} · {{projects}} dự án đang chạy · {{skus}} SKU',
  subRd: 'Tạo lúc {{date}} · {{shown}} / {{total}} dự án · {{skus}} SKU',
  subOwner: 'Tạo lúc {{date}} · {{projects}} dự án · {{skus}} SKU · {{owners}} chủ dự án',
  pendingNotCounted: '{{n}} SKU chờ duyệt không được tính',
  subTickets: 'Tạo lúc {{date}} · {{n}} ticket · {{open}} đang mở · {{overdue}} quá hạn · {{unsent}} chưa từng gửi email',
  projSku: '({{projects}} dự án · {{skus}} SKU)',
  projectsN: '{{n}} dự án',
  projectsOf: '{{shown}} / {{total}} dự án',
  skuN: '{{n}} SKU',
  rowsN: '{{n}} dòng',
  sortBy: 'Sắp xếp theo {{label}}',
  unassigned: 'chưa gán',
  unassignedDev: 'Chưa gán',
  other: 'Khác',
  any: 'bất kỳ',
  daysShort: '{{n}} ngày',
  pinAll: 'Chọn / bỏ chọn mọi dòng',
  filter: {
    all: 'Tất cả',
    none: 'Không có',
    selected: 'Đã chọn {{n}}',
    noOptions: 'Không có lựa chọn',
    clear: 'Xóa bộ lọc',
    allSopTeams: 'Tất cả nhóm Sales OP',
    allOwners: 'Tất cả chủ dự án',
    allReceiving: 'Tất cả bộ phận nhận',
    allRequesters: 'Tất cả người yêu cầu',
    allCodes: 'Tất cả mã ticket',
    allStatuses: 'Mọi trạng thái',
    allStatus: 'Mọi trạng thái',
    allProto: 'Mọi Proto',
    allCategory: 'Mọi danh mục',
    allAssigned: 'Mọi người được giao',
    allItem: 'Mọi mặt hàng',
    allLocation: 'Mọi địa điểm',
    last7: '7 ngày qua',
    from: 'Từ',
    to: 'Đến',
    raisedFrom: 'Tạo từ',
    developer: 'Lọc Developer:',
  },
  col: {
    baseId: 'Base ID',
    styleItem: 'Style / Mặt hàng',
    round: 'Vòng',
    location: 'Địa điểm',
    projectSku: 'SKU dự án',
    devDue: 'Hạn phát triển',
    rmReady: 'RM sẵn sàng',
    sampleFinish: 'Hoàn thành mẫu',
    received: 'Ngày nhận',
    qty: 'SL',
    status: 'Trạng thái',
    dday: 'D-day',
    remarks: 'Ghi chú',
    category: 'Danh mục',
    project: 'Dự án',
    specialProject: 'Dự án đặc biệt',
    assignedTo: 'Giao cho',
    exfShipDate: 'Ngày giao EXF',
    weeksLeft: 'Số tuần còn lại',
    item: 'Mặt hàng',
    estQty: 'SL dự kiến',
    projectStatus: 'Trạng thái dự án',
    ldSoff: 'L/D S/OFF',
    proto: 'Proto',
    counter: 'Counter',
    costing: 'Tính giá',
    handoffMeeting: 'Họp bàn giao',
    alloc: 'Phân bổ',
    shipDate: 'Ngày giao',
    handoff: 'Bàn giao',
    shipmentStatus: 'Trạng thái giao hàng',
    payment: 'Thanh toán',
    dueDays: 'Số ngày đến hạn',
    sampleQty: 'SL mẫu',
    rdRound: 'Vòng R&D',
    remark: 'Ghi chú',
    pin: 'Ghim',
    prjId: 'PRJ ID',
    skuId: 'SKU ID',
    prjOwner: 'Chủ PRJ',
    picAssigned: 'PIC phụ trách',
    exfDate: 'Ngày EXF',
    sku: 'SKU',
    progress: 'Tiến độ',
    approved: 'Đã duyệt',
    developer: 'Developer',
    total: 'Tổng',
    ttl: 'Tổng',
    sample: 'Mẫu',
    noSample: 'Chưa có mẫu',
  },
  thNote: {
    devDesigner: 'developer / designer',
    exfRule: 'SKU chưa xong — ưu tiên TBA, nếu không thì ngày gần nhất',
    avgSkus: 'trung bình các SKU',
    mostActive: 'SKU tích cực nhất',
    dateBy: 'ngày · người duyệt',
    project: 'dự án',
    sku: 'SKU',
    created: 'đã tạo',
    stillOpen: 'vẫn đang mở',
  },
  note: {
    comments: 'Nhận xét',
    saved: 'Đã lưu',
    placeholder: 'Thêm ghi chú tại đây...',
  },
  dev: {
    sec11: 'Phần 1-1: Theo Developer',
    samplesN: '({{n}} mẫu)',
    chunkOf: '({{start}}-{{end}} trên {{total}} mẫu)',
    noSamples: 'Không có mẫu nào khớp với bộ lọc đã chọn.',
    sec12: 'Phần 1-2: Theo nhà cung cấp',
    otherSuppliers: 'Nhà cung cấp khác',
    sec2: 'Phần 2: Sau bàn giao',
    noProjects: 'Không có dự án.',
    onHoldSec: 'TRẠNG THÁI - Tạm dừng / Không hoạt động',
    onHoldTitle: 'Tạm dừng / Không hoạt động',
    noOnHold: 'Không có dự án tạm dừng.',
  },
  rd: {
    noRows: 'Không có dự án R&D nào khớp với bộ lọc đã chọn.',
    untick: 'Bỏ chọn để loại dòng này khỏi lần ghim tiếp theo',
    pinView: 'Ghim chế độ xem này',
    mergeNeed: 'Chọn ít nhất hai chế độ xem đã ghim để gộp',
    mergeDo: 'Gộp các chế độ xem đã chọn thành một bản ghim mới',
    mergeSelected: 'Gộp mục đã chọn ({{n}})',
    clearPinned: 'Xóa bản ghim ({{n}})',
    includeInMerge: 'Đưa chế độ xem này vào lần gộp tiếp theo',
    pinned: 'Bản ghim {{n}} — {{label}}',
    removeSnapshot: 'Xóa bản chụp này',
    merged: 'Đã gộp ({{n}}): {{labels}}',
    mergedDup: '{{label}} — đã bỏ {{n}} dòng trùng',
    noFilter: 'Không lọc (tất cả các dòng)',
    fPart: '{{label}}: {{values}}',
    fStatus: 'Trạng thái',
    fProto: 'Proto',
    fCategory: 'Danh mục',
    fAssigned: 'Người được giao',
    fItem: 'Mặt hàng',
    fLocation: 'Địa điểm',
  },
  ov: {
    title: '4. TỔNG QUAN PHÁT TRIỂN DỰ ÁN - Phân bổ công việc',
    note: '(Trạng thái dự án: On Track / Concern / Delayed. Không tính: Sau bàn giao và On Hold/Inactive)',
    numProject: 'Số dự án',
    numProjectNote: '(On Track / Concern / Delayed; không tính sau bàn giao)',
    numSku: 'Số SKU',
    numSkuNote: '(SKU On Track / Concern / Delayed; không tính sau bàn giao)',
    stageSummary: 'Giai đoạn phát triển - Tóm tắt theo Developer',
    chartProject: 'Số dự án theo Developer',
    chartSku: 'Số SKU theo Developer',
    inDev: 'Đang phát triển',
    postHandoff: 'Sau bàn giao',
    postShipment: 'Sau giao hàng',
    onHold: 'Tạm dừng',
    wlTitle: 'Khối lượng công việc hiện tại - Developer phụ trách',
    wlIntro: 'Mỗi người đang giữ những việc gì lúc này. Developer —',
    wlInCharge: 'Phụ trách',
    wlInChargeText: ': các mẫu họ phụ trách đến khi xong (kể cả mẫu đang chờ phản hồi — có góp ý nghĩa là phải làm thêm một vòng).',
    wlInProgress: 'Đang làm',
    wlInProgressText: ': các vòng trước khi gửi mà developer đang xử lý (đặt RM, phối hợp, làm mẫu, kiểm tra).',
    wlChart: 'Khối lượng công việc hiện tại theo Developer',
    inChargeBase: 'Phụ trách (Base ID)',
    inProgressSample: 'Đang làm (Sample ID)',
    noWorkload: 'Không có công việc mẫu nào đang chạy.',
  },
  owner: {
    sec1: 'Phần 1: Danh mục dự án theo chủ dự án và danh mục',
    sampleCreated: 'Đã tạo mẫu',
    noSampleYet: 'Chưa có mẫu',
    chartProjects: 'Dự án theo chủ dự án',
    chartProjectsNote: 'chia theo danh mục',
    chartSkus: 'SKU theo chủ dự án',
    chartSkusNote: 'đã có mẫu, hoặc vẫn mở mà chưa có mẫu',
    noData: 'Không có dữ liệu cho bộ lọc này.',
    completedSku: 'SKU hoàn thành',
    droppedSku: 'SKU đã hủy',
    activeSku: 'SKU đang chạy',
    noSampleSub: 'vẫn mở, chưa có vòng mẫu',
    sec2: 'Phần 2: Trạng thái dự án theo chủ dự án',
    noMatch: 'Không có dự án nào khớp bộ lọc này.',
    chunk: '{{start}}-{{end}} trên {{total}} dự án',
    approvedSec: 'Dự án đã duyệt · {{range}}',
    projectsApproved: 'Dự án đã duyệt',
    inPeriod: 'trong kỳ này',
    skusApproved: 'SKU đã duyệt',
    acrossProjects: 'trong các dự án đó',
    noApproved: 'Không có dự án nào được duyệt trong kỳ này.',
    sec3: 'Phần 3: Ticket của các dự án này',
    sec3Counts: '({{open}} đang mở · {{overdue}} quá hạn · {{never}} chưa từng gửi email)',
    noTickets: 'Chưa có ticket nào được tạo cho các dự án này.',
    raised: 'Đã tạo',
    open: 'Đang mở',
    overdue: 'Quá hạn',
    neverEmailed: 'Chưa từng gửi email',
    oldestOpen: 'Mở lâu nhất',
    sec4: 'Phần 4: SKU chưa có mẫu',
    allSampled: 'Mọi SKU trong bộ lọc này đều đã có mẫu.',
    nsCountFiltered: '{{n}} / {{total}} SKU · đã lọc',
    clearFilters: 'Xóa bộ lọc',
  },
  tk: {
    colTicket: 'Ticket',
    colProject: 'Dự án',
    colProjectName: 'Tên dự án',
    colAsked: 'Nội dung yêu cầu',
    colReceiving: 'Bộ phận nhận',
    colOwner: 'Chủ dự án',
    colDue: 'Hạn',
    colManager: 'Trạng thái của quản lý',
    colAssignee: 'Trạng thái của bộ phận nhận',
    total: 'Tổng',
    chartAria: 'Ticket {{title}}',
    cardsAria: 'Ticket theo thẻ: {{list}}',
    raisedSub: 'ticket trong chế độ xem này',
    overdueSub: 'đã quá hạn',
    subPending: 'quản lý chưa đóng',
    subDone: 'quản lý đã đóng',
    subCancelled: 'quản lý đã hủy',
    byCard: 'Ticket theo thẻ',
    s1: 'Phần 1: Đang mở',
    s1note: 'Mọi ticket quản lý chưa đóng. Chỉ người yêu cầu, chủ dự án hoặc trưởng nhóm mới có thể đóng ticket.',
    s1empty: 'Không có ticket nào đang mở.',
    s2: 'Phần 2: Quá hạn',
    s2empty: 'Không có ticket nào quá hạn.',
    s3: 'Phần 3: Đã tạo nhưng chưa từng gửi email',
    s3note: 'Chưa ai ở bộ phận nhận được báo về các ticket này. Ticket Station hiển thị nút Send trên từng ticket.',
    s3empty: 'Mọi ticket đang mở đều đã được gửi email.',
    s4: 'Phần 4: Đang mở nhưng bộ phận nhận báo Done',
    s4note: 'Bộ phận nhận đã trả lời Done nhưng ticket vẫn đang mở. Công việc có vẻ đã xong; cần có người đóng ticket.',
    s4empty: 'Không có ticket nào đang chờ đóng.',
    s5: 'Phần 5: Theo bộ phận nhận',
    s6: 'Phần 6: Theo chủ dự án',
    s7: 'Phần 7: Theo mã ticket',
    keyReceiving: 'Bộ phận nhận',
    keyOwner: 'Chủ dự án',
    keyCode: 'Mã ticket',
    noMatch: 'Không có ticket nào khớp bộ lọc này.',
  },
};

const zh = {
  team: {
    special: '综合开发团队',
    inline: 'Inline 开发团队',
    rd: 'R&D 团队',
    owner: '项目负责人报告',
    tickets: '工单中心报告',
  },
  tab: {
    special: '综合开发团队',
    rd: 'R&D 团队',
    owner: '项目负责人',
    tickets: '工单中心',
  },
  exportExcel: '导出 Excel',
  loading: '正在加载项目报告...',
  loadError: '报告加载出错：{{error}}',
  loadFailed: '项目加载失败',
  exportNone: '没有可导出的报告表格。',
  exportFailedStatus: '导出失败（{{status}}）',
  exportFailed: '导出失败：{{error}}',
  subDev: '生成于 {{date}} · {{projects}} 个进行中项目 · {{skus}} 个 SKU',
  subRd: '生成于 {{date}} · {{total}} 个项目中的 {{shown}} 个 · {{skus}} 个 SKU',
  subOwner: '生成于 {{date}} · {{projects}} 个项目 · {{skus}} 个 SKU · {{owners}} 位负责人',
  pendingNotCounted: '{{n}} 个待审批 SKU 未计入',
  subTickets: '生成于 {{date}} · {{n}} 张工单 · {{open}} 张未结 · {{overdue}} 张逾期 · {{unsent}} 张从未发送邮件',
  projSku: '（{{projects}} 个项目 · {{skus}} 个 SKU）',
  projectsN: '{{n}} 个项目',
  projectsOf: '{{shown}} / {{total}} 个项目',
  skuN: '{{n}} 个 SKU',
  rowsN: '{{n}} 行',
  sortBy: '按{{label}}排序',
  unassigned: '未指定',
  unassignedDev: '未指定',
  other: '其他',
  any: '不限',
  daysShort: '{{n}} 天',
  pinAll: '全选 / 取消全选',
  filter: {
    all: '全部',
    none: '无',
    selected: '已选 {{n}} 项',
    noOptions: '无选项',
    clear: '清除筛选',
    allSopTeams: '全部 Sales OP 团队',
    allOwners: '全部项目负责人',
    allReceiving: '全部接收团队',
    allRequesters: '全部申请人',
    allCodes: '全部工单代码',
    allStatuses: '全部状态',
    allStatus: '全部状态',
    allProto: '全部 Proto',
    allCategory: '全部类别',
    allAssigned: '全部负责人',
    allItem: '全部品项',
    allLocation: '全部地点',
    last7: '最近 7 天',
    from: '从',
    to: '至',
    raisedFrom: '创建日期从',
    developer: '开发员筛选：',
  },
  col: {
    baseId: 'Base ID',
    styleItem: '款式 / 品项',
    round: '轮次',
    location: '地点',
    projectSku: '项目 SKU',
    devDue: '开发截止日',
    rmReady: 'RM 就绪',
    sampleFinish: '样品完成',
    received: '接收日期',
    qty: '数量',
    status: '状态',
    dday: 'D-day',
    remarks: '备注',
    category: '类别',
    project: '项目',
    specialProject: '特别项目',
    assignedTo: '负责人',
    exfShipDate: 'EXF 出货日期',
    weeksLeft: '剩余周数',
    item: '品项',
    estQty: '预计数量',
    projectStatus: '项目状态',
    ldSoff: 'L/D S/OFF',
    proto: 'Proto',
    counter: 'Counter',
    costing: '成本核算',
    handoffMeeting: '交接会议',
    alloc: '分配',
    shipDate: '出货日期',
    handoff: '交接',
    shipmentStatus: '出货状态',
    payment: '付款',
    dueDays: '到期天数',
    sampleQty: '样品数量',
    rdRound: 'R&D 轮次',
    remark: '备注',
    pin: '固定',
    prjId: 'PRJ ID',
    skuId: 'SKU ID',
    prjOwner: 'PRJ 负责人',
    picAssigned: '指派 PIC',
    exfDate: 'EXF 日期',
    sku: 'SKU',
    progress: '进度',
    approved: '已批准',
    developer: '开发员',
    total: '合计',
    ttl: '合计',
    sample: '样品',
    noSample: '无样品',
  },
  thNote: {
    devDesigner: '开发员 / 设计师',
    exfRule: '未完成的 SKU — TBA 优先，否则取最近日期',
    avgSkus: 'SKU 平均',
    mostActive: '最活跃的 SKU',
    dateBy: '日期 · 批准人',
    project: '项目',
    sku: 'SKU',
    created: '已创建',
    stillOpen: '仍在进行',
  },
  note: {
    comments: '评论',
    saved: '已保存',
    placeholder: '在此添加备注...',
  },
  dev: {
    sec11: '第 1-1 部分：按开发员',
    samplesN: '（{{n}} 个样品）',
    chunkOf: '（{{total}} 个样品中的 {{start}}-{{end}}）',
    noSamples: '没有符合所选筛选条件的样品。',
    sec12: '第 1-2 部分：按供应商',
    otherSuppliers: '其他供应商',
    sec2: '第 2 部分：交接之后',
    noProjects: '没有项目。',
    onHoldSec: '状态 - 暂停 / 停用',
    onHoldTitle: '暂停 / 停用',
    noOnHold: '没有暂停的项目。',
  },
  rd: {
    noRows: '没有符合所选筛选条件的 R&D 项目。',
    untick: '取消勾选可将此行排除在下一次固定视图之外',
    pinView: '固定此视图',
    mergeNeed: '至少勾选两个已固定的视图才能合并',
    mergeDo: '将勾选的视图合并为一个新的固定视图',
    mergeSelected: '合并所选（{{n}}）',
    clearPinned: '清除固定视图（{{n}}）',
    includeInMerge: '在下一次合并中包含此视图',
    pinned: '固定视图 {{n}} — {{label}}',
    removeSnapshot: '删除此快照',
    merged: '已合并（{{n}}）：{{labels}}',
    mergedDup: '{{label}} — 已移除 {{n}} 个重复行',
    noFilter: '无筛选（全部行）',
    fPart: '{{label}}：{{values}}',
    fStatus: '状态',
    fProto: 'Proto',
    fCategory: '类别',
    fAssigned: '负责人',
    fItem: '品项',
    fLocation: '地点',
  },
  ov: {
    title: '4. 项目开发概览 - 工作分配',
    note: '（项目状态：On Track / Concern / Delayed。不含：交接之后及 On Hold/Inactive）',
    numProject: '项目数',
    numProjectNote: '（On Track / Concern / Delayed；不含交接之后）',
    numSku: 'SKU 数',
    numSkuNote: '（On Track / Concern / Delayed SKU；不含交接之后）',
    stageSummary: '开发阶段 - 开发员汇总',
    chartProject: '各开发员项目数',
    chartSku: '各开发员 SKU 数',
    inDev: '开发中',
    postHandoff: '交接之后',
    postShipment: '出货之后',
    onHold: '暂停',
    wlTitle: '当前工作量 - 开发负责人',
    wlIntro: '每个人当前手上的工作。开发员 —',
    wlInCharge: '负责中',
    wlInChargeText: '：负责到完成为止的样品（包括等待反馈的 — 有评论意味着还要再做一轮）。',
    wlInProgress: '进行中',
    wlInProgressText: '：开发员目前正在处理、尚未寄出的轮次（RM 下单、协调、制作、检查）。',
    wlChart: '各开发员当前工作量',
    inChargeBase: '负责中（Base ID）',
    inProgressSample: '进行中（Sample ID）',
    noWorkload: '没有进行中的样品工作。',
  },
  owner: {
    sec1: '第 1 部分：按负责人和类别的项目组合',
    sampleCreated: '已建样品',
    noSampleYet: '尚无样品',
    chartProjects: '各负责人的项目',
    chartProjectsNote: '按类别细分',
    chartSkus: '各负责人的 SKU',
    chartSkusNote: '已有样品，或仍在进行但尚无样品',
    noData: '此筛选条件下没有数据。',
    completedSku: '已完成 SKU',
    droppedSku: '已放弃 SKU',
    activeSku: '进行中 SKU',
    noSampleSub: '仍在进行，没有样品轮次',
    sec2: '第 2 部分：按负责人的项目状态',
    noMatch: '没有符合此筛选条件的项目。',
    chunk: '{{total}} 个项目中的 {{start}}-{{end}}',
    approvedSec: '已批准项目 · {{range}}',
    projectsApproved: '已批准项目',
    inPeriod: '本期间',
    skusApproved: '已批准 SKU',
    acrossProjects: '上述项目合计',
    noApproved: '本期间没有批准任何项目。',
    sec3: '第 3 部分：这些项目的工单',
    sec3Counts: '（{{open}} 张未结 · {{overdue}} 张逾期 · {{never}} 张从未发送邮件）',
    noTickets: '这些项目尚未创建任何工单。',
    raised: '已创建',
    open: '未结',
    overdue: '逾期',
    neverEmailed: '从未发送邮件',
    oldestOpen: '最久未结',
    sec4: '第 4 部分：尚无样品的 SKU',
    allSampled: '此筛选条件下的每个 SKU 都已有样品。',
    nsCountFiltered: '{{total}} 个 SKU 中的 {{n}} 个 · 已筛选',
    clearFilters: '清除筛选',
  },
  tk: {
    colTicket: '工单',
    colProject: '项目',
    colProjectName: '项目名称',
    colAsked: '请求内容',
    colReceiving: '接收团队',
    colOwner: '项目负责人',
    colDue: '期限',
    colManager: '经理状态',
    colAssignee: '接收团队状态',
    total: '合计',
    chartAria: '工单 {{title}}',
    cardsAria: '按卡片的工单：{{list}}',
    raisedSub: '此视图中的工单',
    overdueSub: '已过期限',
    subPending: '经理尚未关闭',
    subDone: '经理已关闭',
    subCancelled: '经理已取消',
    byCard: '按卡片的工单',
    s1: '第 1 部分：未结',
    s1note: '经理尚未关闭的所有工单。只有申请人、项目负责人或团队经理可以关闭工单。',
    s1empty: '没有未结工单。',
    s2: '第 2 部分：逾期',
    s2empty: '没有逾期的工单。',
    s3: '第 3 部分：已创建但从未发送邮件',
    s3note: '接收团队中没有人知道这些工单存在。工单中心在每张工单上都显示 Send 按钮。',
    s3empty: '所有未结工单都已发送邮件。',
    s4: '第 4 部分：未结，但接收团队已答复 Done',
    s4note: '接收团队已答复 Done，但工单仍未结。工作看起来已完成，需要有人关闭它。',
    s4empty: '没有等待关闭的工单。',
    s5: '第 5 部分：按接收团队',
    s6: '第 6 部分：按项目负责人',
    s7: '第 7 部分：按工单代码',
    keyReceiving: '接收团队',
    keyOwner: '项目负责人',
    keyCode: '工单代码',
    noMatch: '没有符合此筛选条件的工单。',
  },
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "team": {
    "special": "Équipe de développement intégré",
    "inline": "Équipe de développement Inline",
    "rd": "Équipe R&D",
    "owner": "Rapport pour le responsable de projet",
    "tickets": "Rapport pour Ticket Station"
  },
  "tab": {
    "special": "Équipe de développement intégré",
    "rd": "Équipe R&D",
    "owner": "Responsable de projet",
    "tickets": "Ticket Station"
  },
  "exportExcel": "Exporter vers Excel",
  "loading": "Chargement du rapport de projets...",
  "loadError": "Erreur lors du chargement du rapport : {{error}}",
  "loadFailed": "Échec du chargement des projets",
  "exportNone": "Aucun tableau de rapport à exporter.",
  "exportFailedStatus": "Échec de l'export ({{status}})",
  "exportFailed": "Échec de l'export : {{error}}",
  "subDev": "Généré le {{date}} · {{projects}} projets actifs · {{skus}} SKU",
  "subRd": "Généré le {{date}} · {{shown}} sur {{total}} projets · {{skus}} SKU",
  "subOwner": "Généré le {{date}} · {{projects}} projets · {{skus}} SKU · {{owners}} responsables",
  "pendingNotCounted": "{{n}} SKU en attente d'approbation non comptés",
  "subTickets": "Généré le {{date}} · {{n}} tickets · {{open}} ouverts · {{overdue}} en retard · {{unsent}} jamais envoyés par e-mail",
  "projSku": "({{projects}} projets · {{skus}} SKU)",
  "projectsN": "{{n}} projets",
  "projectsOf": "{{shown}} / {{total}} projets",
  "skuN": "{{n}} SKU",
  "rowsN": "{{n}} lignes",
  "sortBy": "Trier par {{label}}",
  "unassigned": "non attribué",
  "unassignedDev": "Non attribué",
  "other": "Autre",
  "any": "tous",
  "daysShort": "{{n}} j",
  "pinAll": "Cocher / décocher toutes les lignes",
  "filter": {
    "all": "Tout",
    "none": "Aucun",
    "selected": "{{n}} sélectionné(s)",
    "noOptions": "Aucune option",
    "clear": "Effacer les filtres",
    "allSopTeams": "Toutes les Sales OP Teams",
    "allOwners": "Tous les responsables de projet",
    "allReceiving": "Toutes les équipes destinataires",
    "allRequesters": "Tous les demandeurs",
    "allCodes": "Tous les codes de ticket",
    "allStatuses": "Tous les statuts",
    "allStatus": "Tous les statuts",
    "allProto": "Tous les Proto",
    "allCategory": "Toutes les catégories",
    "allAssigned": "Tous les assignés",
    "allItem": "Tous les articles",
    "allLocation": "Tous les emplacements",
    "last7": "7 derniers jours",
    "from": "Du",
    "to": "Au",
    "raisedFrom": "Créé à partir du",
    "developer": "Filtre développeur :"
  },
  "col": {
    "baseId": "Base ID",
    "styleItem": "Style / Article",
    "round": "Tour",
    "location": "Emplacement",
    "projectSku": "SKU du projet",
    "devDue": "Échéance de développement",
    "rmReady": "RM prête",
    "sampleFinish": "Fin de l'échantillon",
    "received": "Reçu",
    "qty": "QTÉ",
    "status": "Statut",
    "dday": "D-day",
    "remarks": "Remarques",
    "category": "Catégorie",
    "project": "Projet",
    "specialProject": "Projet spécial",
    "assignedTo": "Assigné à",
    "exfShipDate": "Date d'expédition EXF",
    "weeksLeft": "Semaines restantes",
    "item": "Article",
    "estQty": "QTÉ estimée",
    "projectStatus": "Statut du projet",
    "ldSoff": "L/D S/OFF",
    "proto": "Proto",
    "counter": "Counter",
    "costing": "Calcul des coûts",
    "handoffMeeting": "Réunion de passation",
    "alloc": "Alloc",
    "shipDate": "Date d'expédition",
    "handoff": "Passation",
    "shipmentStatus": "Statut d'expédition",
    "payment": "Paiement",
    "dueDays": "Jours d'échéance",
    "sampleQty": "QTÉ échantillon",
    "rdRound": "Tour R&D",
    "remark": "Remarque",
    "pin": "Épingler",
    "prjId": "PRJ ID",
    "skuId": "SKU ID",
    "prjOwner": "Responsable PRJ",
    "picAssigned": "PIC assigné",
    "exfDate": "Date EXF",
    "sku": "SKU",
    "progress": "Avancement",
    "approved": "Approuvé",
    "developer": "Développeur",
    "total": "Total",
    "ttl": "TTL",
    "sample": "Échantillon",
    "noSample": "Sans échantillon"
  },
  "thNote": {
    "devDesigner": "développeur / designer",
    "exfRule": "SKU non terminés — TBA d'abord, sinon le plus proche",
    "avgSkus": "moyenne des SKU",
    "mostActive": "SKU le plus actif",
    "dateBy": "date · par",
    "project": "projet",
    "sku": "SKU",
    "created": "créé",
    "stillOpen": "encore ouvert"
  },
  "note": {
    "comments": "Commentaires",
    "saved": "Enregistré",
    "placeholder": "Ajoutez des notes ici..."
  },
  "dev": {
    "sec11": "Section 1-1 : Par développeur",
    "samplesN": "({{n}} échantillons)",
    "chunkOf": "({{start}}-{{end}} sur {{total}} échantillons)",
    "noSamples": "Aucun échantillon ne correspond aux filtres sélectionnés.",
    "sec12": "Section 1-2 : Par fournisseur",
    "otherSuppliers": "Autres fournisseurs",
    "sec2": "Section 2 : Après passation",
    "noProjects": "Aucun projet.",
    "onHoldSec": "STATUT - En pause / Inactif",
    "onHoldTitle": "En pause / Inactif",
    "noOnHold": "Aucun projet en pause."
  },
  "rd": {
    "noRows": "Aucun projet R&D ne correspond aux filtres sélectionnés.",
    "untick": "Décochez pour exclure cette ligne de la prochaine vue épinglée",
    "pinView": "Épingler cette vue",
    "mergeNeed": "Cochez au moins deux vues épinglées pour les fusionner",
    "mergeDo": "Fusionner les vues cochées en une nouvelle épingle",
    "mergeSelected": "Fusionner la sélection ({{n}})",
    "clearPinned": "Effacer les épingles ({{n}})",
    "includeInMerge": "Inclure cette vue dans la prochaine fusion",
    "pinned": "Épinglé {{n}} — {{label}}",
    "removeSnapshot": "Supprimer cet instantané",
    "merged": "Fusionné ({{n}}) : {{labels}}",
    "mergedDup": "{{label}} — {{n}} ligne(s) en double supprimée(s)",
    "noFilter": "Aucun filtre (toutes les lignes)",
    "fPart": "{{label}} : {{values}}",
    "fStatus": "Statut",
    "fProto": "Proto",
    "fCategory": "Catégorie",
    "fAssigned": "Assigné",
    "fItem": "Article",
    "fLocation": "Emplacement"
  },
  "ov": {
    "title": "4. VUE D'ENSEMBLE DU DÉVELOPPEMENT DES PROJETS - Répartition du travail",
    "note": "(Statut du projet : Dans les temps / À surveiller / En retard. Non inclus : Après passation et En pause/Inactif)",
    "numProject": "Nombre de projets",
    "numProjectNote": "(Dans les temps / À surveiller / En retard ; hors Après passation)",
    "numSku": "Nombre de SKU",
    "numSkuNote": "(SKU dans les temps / à surveiller / en retard ; hors Après passation)",
    "stageSummary": "Étape de développement - Synthèse par développeur",
    "chartProject": "Nombre de projets par développeur",
    "chartSku": "Nombre de SKU par développeur",
    "inDev": "En développement",
    "postHandoff": "Après passation",
    "postShipment": "Après expédition",
    "onHold": "En pause",
    "wlTitle": "Aperçu de la charge actuelle - Développeur responsable",
    "wlIntro": "Ce que chaque personne a en main actuellement. Développeur —",
    "wlInCharge": "En charge",
    "wlInChargeText": " : échantillons dont il est responsable jusqu'à leur finalisation (y compris ceux en attente de retour — un commentaire implique un nouveau tour).",
    "wlInProgress": "En cours",
    "wlInProgressText": " : tours avant envoi que le développeur traite actuellement (commande RM, coordination, fabrication, contrôles).",
    "wlChart": "Charge actuelle par développeur",
    "inChargeBase": "En charge (Base ID)",
    "inProgressSample": "En cours (Sample ID)",
    "noWorkload": "Aucune charge d'échantillons active trouvée."
  },
  "owner": {
    "sec1": "Section 1 : Portefeuille de projets par responsable et catégorie",
    "sampleCreated": "Échantillon créé",
    "noSampleYet": "Pas encore d'échantillon",
    "chartProjects": "Projets par responsable",
    "chartProjectsNote": "répartis par catégorie",
    "chartSkus": "SKU par responsable",
    "chartSkusNote": "échantillonnés, ou encore ouverts sans échantillon",
    "noData": "Aucune donnée pour ce filtre.",
    "completedSku": "SKU terminés",
    "droppedSku": "SKU abandonnés",
    "activeSku": "SKU actifs",
    "noSampleSub": "encore ouvert, aucun tour d'échantillon",
    "sec2": "Section 2 : Statut des projets par responsable",
    "noMatch": "Aucun projet ne correspond à ce filtre.",
    "chunk": "{{start}}-{{end}} sur {{total}} projets",
    "approvedSec": "Projets approuvés · {{range}}",
    "projectsApproved": "Projets approuvés",
    "inPeriod": "sur cette période",
    "skusApproved": "SKU approuvés",
    "acrossProjects": "dans ces projets",
    "noApproved": "Aucun projet n'a été approuvé sur cette période.",
    "sec3": "Section 3 : Tickets sur ces projets",
    "sec3Counts": "({{open}} ouverts · {{overdue}} en retard · {{never}} jamais envoyés par e-mail)",
    "noTickets": "Aucun ticket n'a été créé sur ces projets.",
    "raised": "Créés",
    "open": "Ouverts",
    "overdue": "En retard",
    "neverEmailed": "Jamais envoyés par e-mail",
    "oldestOpen": "Plus ancien ouvert",
    "sec4": "Section 4 : SKU sans échantillon",
    "allSampled": "Tous les SKU de ce filtre ont un échantillon.",
    "nsCountFiltered": "{{n}} SKU sur {{total}} · filtré",
    "clearFilters": "Effacer les filtres"
  },
  "tk": {
    "colTicket": "Ticket",
    "colProject": "Projet",
    "colProjectName": "Nom du projet",
    "colAsked": "Objet de la demande",
    "colReceiving": "Équipe destinataire",
    "colOwner": "Responsable du projet",
    "colDue": "Échéance",
    "colManager": "Statut du manager",
    "colAssignee": "Statut de l'assigné",
    "total": "Total",
    "chartAria": "Tickets {{title}}",
    "cardsAria": "Tickets par carte : {{list}}",
    "raisedSub": "tickets dans cette vue",
    "overdueSub": "échéance dépassée",
    "subPending": "le manager ne l'a pas clôturé",
    "subDone": "le manager l'a clôturé",
    "subCancelled": "le manager l'a annulé",
    "byCard": "Tickets par carte",
    "s1": "Section 1 : Ouverts",
    "s1note": "Tous les tickets que le manager n'a pas clôturés. Seuls le demandeur, le responsable du projet ou le manager de l'équipe peuvent en clôturer un.",
    "s1empty": "Aucun ticket ouvert.",
    "s2": "Section 2 : En retard",
    "s2empty": "Aucun ticket n'a dépassé son échéance.",
    "s3": "Section 3 : Créés mais jamais envoyés par e-mail",
    "s3note": "Personne dans l'équipe destinataire n'a été informé de leur existence. Ticket Station affiche un bouton Envoyer sur chacun d'eux.",
    "s3empty": "Tous les tickets ouverts ont été envoyés par e-mail.",
    "s4": "Section 4 : Ouverts, mais l'équipe destinataire indique Terminé",
    "s4note": "L'équipe destinataire a répondu Terminé et le ticket est toujours ouvert. Le travail semble terminé ; quelqu'un doit le clôturer.",
    "s4empty": "Aucun ticket en attente de clôture.",
    "s5": "Section 5 : Par équipe destinataire",
    "s6": "Section 6 : Par responsable de projet",
    "s7": "Section 7 : Par code de ticket",
    "keyReceiving": "Équipe destinataire",
    "keyOwner": "Responsable du projet",
    "keyCode": "Code de ticket",
    "noMatch": "Aucun ticket ne correspond à ce filtre."
  }
};
const ja = {
  "team": {
    "special": "統合開発チーム",
    "inline": "インライン開発チーム",
    "rd": "R&Dチーム",
    "owner": "プロジェクトオーナー向けレポート",
    "tickets": "Ticket Station向けレポート"
  },
  "tab": {
    "special": "統合開発チーム",
    "rd": "R&Dチーム",
    "owner": "プロジェクトオーナー",
    "tickets": "Ticket Station"
  },
  "exportExcel": "Excelエクスポート",
  "loading": "プロジェクトレポートを読み込み中...",
  "loadError": "レポートの読み込みエラー：{{error}}",
  "loadFailed": "プロジェクトの読み込みに失敗しました",
  "exportNone": "エクスポートするレポート表がありません。",
  "exportFailedStatus": "エクスポートに失敗しました（{{status}}）",
  "exportFailed": "エクスポートに失敗しました：{{error}}",
  "subDev": "作成日 {{date}}・有効プロジェクト{{projects}}件・{{skus}} SKU",
  "subRd": "作成日 {{date}}・プロジェクト{{total}}件中{{shown}}件・{{skus}} SKU",
  "subOwner": "作成日 {{date}}・プロジェクト{{projects}}件・{{skus}} SKU・オーナー{{owners}}名",
  "pendingNotCounted": "承認待ちの{{n}} SKUは集計に含まれていません",
  "subTickets": "作成日 {{date}}・チケット{{n}}件・未完了{{open}}件・期限超過{{overdue}}件・メール未送信{{unsent}}件",
  "projSku": "（プロジェクト{{projects}}件・{{skus}} SKU）",
  "projectsN": "プロジェクト{{n}}件",
  "projectsOf": "プロジェクト{{shown}} / {{total}}件",
  "skuN": "{{n}} SKU",
  "rowsN": "{{n}}行",
  "sortBy": "{{label}}で並べ替え",
  "unassigned": "未割当",
  "unassignedDev": "未割当",
  "other": "その他",
  "any": "すべて",
  "daysShort": "{{n}}日",
  "pinAll": "全行をチェック／チェック解除",
  "filter": {
    "all": "すべて",
    "none": "なし",
    "selected": "{{n}}件選択中",
    "noOptions": "選択肢なし",
    "clear": "フィルターをクリア",
    "allSopTeams": "すべてのSales OP Team",
    "allOwners": "すべてのプロジェクトオーナー",
    "allReceiving": "すべての受付チーム",
    "allRequesters": "すべての依頼者",
    "allCodes": "すべてのチケットコード",
    "allStatuses": "すべてのステータス",
    "allStatus": "すべてのステータス",
    "allProto": "すべてのProto",
    "allCategory": "すべてのカテゴリ",
    "allAssigned": "すべての担当者",
    "allItem": "すべてのアイテム",
    "allLocation": "すべての所在地",
    "last7": "過去7日間",
    "from": "開始",
    "to": "終了",
    "raisedFrom": "起票日（開始）",
    "developer": "開発担当フィルター："
  },
  "col": {
    "baseId": "Base ID",
    "styleItem": "スタイル／アイテム",
    "round": "ラウンド",
    "location": "所在地",
    "projectSku": "プロジェクトSKU",
    "devDue": "開発期日",
    "rmReady": "RM準備完了",
    "sampleFinish": "サンプル完成",
    "received": "受領",
    "qty": "数量",
    "status": "ステータス",
    "dday": "D-day",
    "remarks": "備考",
    "category": "カテゴリ",
    "project": "プロジェクト",
    "specialProject": "特別プロジェクト",
    "assignedTo": "担当",
    "exfShipDate": "EXF出荷日",
    "weeksLeft": "残り週数",
    "item": "アイテム",
    "estQty": "予定数量",
    "projectStatus": "プロジェクトステータス",
    "ldSoff": "L/D S/OFF",
    "proto": "Proto",
    "counter": "Counter",
    "costing": "原価計算",
    "handoffMeeting": "引き継ぎ会議",
    "alloc": "Alloc",
    "shipDate": "出荷日",
    "handoff": "引き継ぎ",
    "shipmentStatus": "出荷ステータス",
    "payment": "支払",
    "dueDays": "期日までの日数",
    "sampleQty": "サンプル数量",
    "rdRound": "R&Dラウンド",
    "remark": "備考",
    "pin": "ピン留め",
    "prjId": "PRJ ID",
    "skuId": "SKU ID",
    "prjOwner": "PRJオーナー",
    "picAssigned": "PIC担当",
    "exfDate": "EXF日",
    "sku": "SKU",
    "progress": "進捗",
    "approved": "承認済み",
    "developer": "開発担当",
    "total": "合計",
    "ttl": "TTL",
    "sample": "サンプル",
    "noSample": "サンプルなし"
  },
  "thNote": {
    "devDesigner": "開発担当／デザイナー",
    "exfRule": "未完了SKU。TBAを優先、なければ最も近い日付",
    "avgSkus": "SKUの平均",
    "mostActive": "最も動きのあるSKU",
    "dateBy": "日付・担当",
    "project": "プロジェクト",
    "sku": "SKU",
    "created": "作成",
    "stillOpen": "未完了"
  },
  "note": {
    "comments": "コメント",
    "saved": "保存済み",
    "placeholder": "ここにメモを入力..."
  },
  "dev": {
    "sec11": "セクション1-1：開発担当別",
    "samplesN": "（サンプル{{n}}件）",
    "chunkOf": "（サンプル{{total}}件中{{start}}-{{end}}件）",
    "noSamples": "選択したフィルターに該当するサンプルはありません。",
    "sec12": "セクション1-2：仕入先別",
    "otherSuppliers": "その他の仕入先",
    "sec2": "セクション2：引き継ぎ後",
    "noProjects": "プロジェクトはありません。",
    "onHoldSec": "ステータス - 保留／休止",
    "onHoldTitle": "保留／休止",
    "noOnHold": "保留中のプロジェクトはありません。"
  },
  "rd": {
    "noRows": "選択したフィルターに該当するR&Dプロジェクトはありません。",
    "untick": "チェックを外すと、この行は次のピン留めビューから除外されます",
    "pinView": "このビューをピン留め",
    "mergeNeed": "統合するには、ピン留めしたビューを2つ以上チェックしてください",
    "mergeDo": "チェックしたビューを1つの新しいピンに統合",
    "mergeSelected": "選択を統合（{{n}}）",
    "clearPinned": "ピン留めをクリア（{{n}}）",
    "includeInMerge": "このビューを次回の統合に含める",
    "pinned": "ピン留め {{n}}：{{label}}",
    "removeSnapshot": "このスナップショットを削除",
    "merged": "統合済み（{{n}}）：{{labels}}",
    "mergedDup": "{{label}}：重複行{{n}}件を削除",
    "noFilter": "フィルターなし（全行）",
    "fPart": "{{label}}：{{values}}",
    "fStatus": "ステータス",
    "fProto": "Proto",
    "fCategory": "カテゴリ",
    "fAssigned": "担当",
    "fItem": "アイテム",
    "fLocation": "所在地"
  },
  "ov": {
    "title": "4. プロジェクト開発の概要 - 業務配分",
    "note": "（プロジェクトステータス：順調／懸念／遅延。対象外：引き継ぎ後、保留／休止）",
    "numProject": "プロジェクト数",
    "numProjectNote": "（順調／懸念／遅延。引き継ぎ後は含みません）",
    "numSku": "SKU数",
    "numSkuNote": "（順調／懸念／遅延のSKU。引き継ぎ後は含みません）",
    "stageSummary": "開発段階：開発担当別サマリー",
    "chartProject": "開発担当別プロジェクト数",
    "chartSku": "開発担当別SKU数",
    "inDev": "開発中",
    "postHandoff": "引き継ぎ後",
    "postShipment": "出荷後",
    "onHold": "保留",
    "wlTitle": "現在の業務量スナップショット：開発担当",
    "wlIntro": "各担当者が現在抱えている業務です。開発担当：",
    "wlInCharge": "担当中",
    "wlInChargeText": "：完了するまで自分が担当するサンプル（フィードバック待ちを含みます。コメントがあれば次のラウンドを作成します）。",
    "wlInProgress": "進行中",
    "wlInProgressText": "：送付前のラウンドで、開発担当が現在対応しているもの（RM発注、調整、制作、確認）。",
    "wlChart": "開発担当別の現在の業務量",
    "inChargeBase": "担当中（Base ID）",
    "inProgressSample": "進行中（Sample ID）",
    "noWorkload": "対応中のサンプル業務は見つかりませんでした。"
  },
  "owner": {
    "sec1": "セクション1：オーナー・カテゴリ別プロジェクトポートフォリオ",
    "sampleCreated": "サンプル作成済み",
    "noSampleYet": "サンプル未作成",
    "chartProjects": "オーナー別プロジェクト",
    "chartProjectsNote": "カテゴリ別の内訳",
    "chartSkus": "オーナー別SKU",
    "chartSkusNote": "サンプル作成済み、またはサンプル未作成で進行中",
    "noData": "このフィルターに該当するデータはありません。",
    "completedSku": "完了SKU",
    "droppedSku": "中止SKU",
    "activeSku": "進行中SKU",
    "noSampleSub": "進行中・サンプルラウンドなし",
    "sec2": "セクション2：オーナー別プロジェクトステータス",
    "noMatch": "このフィルターに該当するプロジェクトはありません。",
    "chunk": "プロジェクト{{total}}件中{{start}}-{{end}}件",
    "approvedSec": "承認済みプロジェクト・{{range}}",
    "projectsApproved": "承認済みプロジェクト",
    "inPeriod": "この期間",
    "skusApproved": "承認済みSKU",
    "acrossProjects": "これらのプロジェクト全体",
    "noApproved": "この期間に承認されたプロジェクトはありません。",
    "sec3": "セクション3：これらのプロジェクトのチケット",
    "sec3Counts": "（未完了{{open}}件・期限超過{{overdue}}件・メール未送信{{never}}件）",
    "noTickets": "これらのプロジェクトにチケットは起票されていません。",
    "raised": "起票",
    "open": "未完了",
    "overdue": "期限超過",
    "neverEmailed": "メール未送信",
    "oldestOpen": "最も古い未完了",
    "sec4": "セクション4：サンプル未作成のSKU",
    "allSampled": "このフィルター内のすべてのSKUにサンプルがあります。",
    "nsCountFiltered": "{{total}}件中{{n}} SKU・フィルター適用中",
    "clearFilters": "フィルターをクリア"
  },
  "tk": {
    "colTicket": "チケット",
    "colProject": "プロジェクト",
    "colProjectName": "プロジェクト名",
    "colAsked": "依頼内容",
    "colReceiving": "受付チーム",
    "colOwner": "プロジェクトオーナー",
    "colDue": "期日",
    "colManager": "マネージャーのステータス",
    "colAssignee": "担当者のステータス",
    "total": "合計",
    "chartAria": "チケット {{title}}",
    "cardsAria": "カード別チケット：{{list}}",
    "raisedSub": "この表示内のチケット",
    "overdueSub": "期日超過",
    "subPending": "マネージャーが未完了",
    "subDone": "マネージャーが完了",
    "subCancelled": "マネージャーがキャンセル",
    "byCard": "カード別チケット",
    "s1": "セクション1：未完了",
    "s1note": "マネージャーがまだ完了にしていないすべてのチケットです。完了にできるのは、依頼者、プロジェクトオーナー、チームマネージャーのみです。",
    "s1empty": "未完了のものはありません。",
    "s2": "セクション2：期限超過",
    "s2empty": "期日を過ぎているものはありません。",
    "s3": "セクション3：起票済みでメール未送信",
    "s3note": "受付チームの誰にもこれらの存在が伝わっていません。Ticket Stationでは、各チケットに送信ボタンが表示されます。",
    "s3empty": "未完了のチケットはすべてメール送信済みです。",
    "s4": "セクション4：未完了だが受付チームが「完了」と回答",
    "s4note": "受付チームは完了と回答していますが、チケットはまだ未完了です。作業は終わっているようです。誰かが完了にする必要があります。",
    "s4empty": "完了待ちのものはありません。",
    "s5": "セクション5：受付チーム別",
    "s6": "セクション6：プロジェクトオーナー別",
    "s7": "セクション7：チケットコード別",
    "keyReceiving": "受付チーム",
    "keyOwner": "プロジェクトオーナー",
    "keyCode": "チケットコード",
    "noMatch": "このフィルターに該当するチケットはありません。"
  }
};

const dictionary = { ns: 'xReport', en, ko, vi, zh, fr, ja };

export default dictionary;
